import React, { useContext } from 'react';
import { PoseGroup } from 'react-pose';
import {
  ModalBlock,
  Modalfilm,
  ModalIcontBlock,
  ModalContent,
  ModalTextBlock,
  ModalButtonBlock,
  IconImg,
} from '../../style/ModalStyle';
import Button from '../Button';
import Fonts from '../Fonts';
import { AppContext } from '../../context/app';

import icon from '../../asset/all/success.png';

export default ({ active, handlHide }) => {
  const { t } = useContext(AppContext);
  return (
    <PoseGroup>
      {active && (
        <ModalBlock key="ModalBlock">
          <Modalfilm
            onClick={() => {
              handlHide();
            }}
          />
          <ModalContent>
            <ModalIcontBlock>
              <IconImg src={icon} style={{ width: 94 }} />
            </ModalIcontBlock>
            <ModalTextBlock>
              <Fonts
                text={t(['success'])}
                fontSize={18}
                fontWeight="bold"
                color="#333333"
              />
            </ModalTextBlock>
            <ModalButtonBlock>
              <Button
                type="primary"
                onClick={() => {
                  handlHide();
                }}
              >
                <Fonts text={t(['ok'])} fontSize={12} color="#fff" />
              </Button>
            </ModalButtonBlock>
          </ModalContent>
        </ModalBlock>
      )}
    </PoseGroup>
  );
};
